// extracted by mini-css-extract-plugin
export default {"textContainer":"main_textContainer__cQ4wk","closeButton":"main_closeButton__msX87","logoutButton":"main_logoutButton__Gw9lV","btnContainer":"main_btnContainer__cBw+-"};